const state = {};

const getters = {};

const mutations = {};

const actions = {
  fetchAll(ctx) {
    return new Promise(function (resolve, reject) {
      axios
        .get('/api/categories')
        .then(({ data: { data: categories } }) => {
          resolve(categories);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  add(ctx, data) {
    return new Promise(function (resolve, reject) {
      axios
        .get('/sanctum/csrf-cookie')
        .then(() => {
          axios
            .post('/api/categories', data)
            .then(({ data: { success, message } }) => {
              resolve({ success, message });
            })
            .catch((error) => {
              reject(error.response.data);
            });
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  fetchByID(ctx, id) {
    return new Promise(function (resolve, reject) {
      axios
        .get(`/api/categories/${id}`)
        .then(({ data: { data: category } }) => {
          resolve(category);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  updateByID(ctx, { id, data }) {
    return new Promise(function (resolve, reject) {
      axios
        .get('/sanctum/csrf-cookie')
        .then(() => {
          axios
            .post(`/api/categories/${id}`, { ...data, _method: 'put' })
            .then(({ data: { success, message } }) => {
              resolve({ success, message });
            })
            .catch((error2) => {
              reject(error2.response.data);
            });
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  deleteByID(ctx, id) {
    return new Promise(function (resolve, reject) {});
  },
};

const namespaced = true;

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced,
};
